class PointMeasure {
	constructor(points, dpi) {
		this.points = points;
		this.dpi = dpi;
	}
	toInch() {
		return this.points / 72;
	}
	toMM() {
		return this.points / (72 * 25.4);
	}
	toPixel(zoom) {
		return ((this.dpi * this.points) / 72) / Math.pow(2, 5 - zoom || 0);
	}
}

export default PointMeasure;



// WEBPACK FOOTER //
// ./src/components/PointMeasure.js